<template>
    <div
        class="position-absolute rounded d-flex align-items-center cursor-pointer timeline-block"
        :class="{
            'bg-primary': variant === 'primary',
            'bg-regular': variant === 'regular'
        }"
        :style="{
            left: leftPosition,
            width: widthBlock
        }"
        @click="toggleDropdown"
    >
        <div class="d-flex flex-grow-1 align-items-center justify-content-end">
            <div v-if="text" class="text-white flex-grow-1 text-center">
                {{ text }}
            </div>
            <b-dropdown
                ref="dropdown"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
                lazy
                @shown="isDropdownShown = true"
                @hidden="isDropdownShown = false"
            >
                <template v-slot:button-content>
                    <i class="fas fa-ellipsis-v text-white"></i>
                </template>
                <b-dropdown-text class="text-right">
                    {{ getTime(event.start) }} - {{ getTime(event.end) }}
                </b-dropdown-text>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button
                    @click="$emit('edit', event)"
                    class="text-right"
                >
                    Edit
                </b-dropdown-item-button>
                <b-dropdown-item-button
                    @click="$emit('delete', event)"
                    class="text-right"
                >
                    Delete
                </b-dropdown-item-button>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
    inject: {
        getRangeBetweenBlock: {
            from: "rangeBetweenBlock"
        }
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        start: {
            type: Number,
            required: true
        },
        end: {
            type: Number,
            required: true
        },
        variant: {
            type: String,
            default: "regular",
            validator: value => ["regular", "primary"].includes(value)
        },
        text: {
            type: String,
            default: null
        }
    },
    computed: {
        leftPosition() {
            return `${this.start * this.getRangeBetweenBlock()}px`;
        },
        widthBlock() {
            return `${(this.end - this.start) * this.getRangeBetweenBlock()}px`;
        }
    },
    data() {
        return {
            isDropdownShown: false
        };
    },
    methods: {
        toggleDropdown(event) {
            // If clicking on the dropdown button itself, let bootstrap-vue handle it
            if (event.target.closest(".dropdown-toggle")) {
                return;
            }

            if (this.isDropdownShown) {
                this.$refs.dropdown.hide();
                this.isDropdownShown = false;
            } else {
                this.$refs.dropdown.show();
                this.isDropdownShown = true;
            }
        },
        getTime(totalMinutes) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            const specificDate = DateTime.now().set({
                hour: hours,
                minute: minutes,
                second: 0
            });

            const formattedTime = specificDate.toFormat("hh:mm a");

            return formattedTime;
        }
    }
};
</script>

<style scoped>
.bg-regular {
    background-color: #67961c;
}

.timeline-block {
    top: 0;
    bottom: 0;
    height: 30px;
    margin: auto;
}

li > p.b-dropdown-text {
    padding: 0.25rem 1.2rem;
    text-wrap: nowrap;
}
</style>
